import Vue from "vue";
import Vuex from "vuex";
import { db } from '../auth';
//import { createClient, updateClient, deleteClient, getClients, getProjects } from './connect';
import * as connect from './connect';
import { getDashboardInfo } from './engine';
import Enumerable from 'linq';
import { getFormattedValue } from "@/shared.js";
import moment from "moment";

Vue.use(Vuex);

const getAllinvoices = (projects) => {
  let invoices = Enumerable.from(projects).select(p => p.invoices);
  let invoicesArray = invoices.toArray();
  let items = invoicesArray.map(inv => Object.values(inv)).flat();
  return Enumerable.from(items);
};

function calculateProjectStatus(project) {

  try {

    let invoices = Enumerable.from(project.invoices).select(p => p.value).toArray();
    let invoicesPaid = invoices.filter(i => i.datePaid);
    let expenses = Enumerable.from(project.expenses).select(p => p.value).toArray();
    let timesheets = Enumerable.from(project.timesheets).select(p => p.value).toArray();

    const reducerByAmount = (acc, item) => acc += Number(item.amount);
    const reducerByValue = (acc, item) => acc += Number(item.value);
    const reducerByHours = (acc, item) => acc += Number(item.timeHours);
    const reducerByMins = (acc, item) => acc += Number(item.timeMins);

    project.invoiced = invoices.reduce(reducerByAmount, 0);
    project.received = invoicesPaid.reduce(reducerByAmount, 0);
    project.expense = expenses.reduce(reducerByValue, 0);
    project.profit = project.received - project.expense;
    let hours = timesheets.reduce(reducerByHours, 0);
    let mins = timesheets.reduce(reducerByMins, 0);
    hours += Math.floor(mins / 60);
    let remainder = (mins % 60);
    if (remainder > 0)
      hours += (remainder / 60);

    project.hours = hours > 0 ? hours.toFixed(1) : 0;

    let money = project.profit > 0 ? project.profit : (project.invoiced - project.expense);
    project.hourlyfee = project.hours > 0 ? money / project.hours : 0;
  }
  catch (err) {
    console.log("calculateProjectStatus: " + err);
  }
}

function clearProjectCalcs(project) {
  delete project.invoiced;
  delete project.received;
  delete project.expense;
  delete project.profit;
  delete project.hours;
  delete project.hourlyfee;
}

function createFilterClient(client) {
  return props => {
    return props.reduce((acc, prop) => acc + (client[prop] || '') + "|", "").toLowerCase();
  };
};

function filterClient(txt) {
  return client => {
    let cf = createFilterClient(client);
    let filter = cf(['firstName', 'lastName', 'city', 'addressLine1', 'addressLine2']);
    return filter.includes(txt);
  };
};

export default new Vuex.Store({
  state: {
    userAuth: null,
    userInfo: null,
    onMobile: false,
    userInfoCloned: null,
    // allStatuses: [],
    // allTypes: [],
    projects: null,
    filterStatus: "all",
    filterTextProjects: "",
    filterTextClients: "",
    clients: null,
    selectedProject: null,
    loginError: "",
  },
  mutations: {
    SET_LOGIN_ERROR(state, error) {
      state.loginError = error;
    },
    SET_USER_AUTH(state, user) {
      state.userAuth = user;
    },
    SET_USER_INFO(state, info) {
      console.log("Setting state.userInfo to " + info);
      state.userInfo = info;
    },
    SET_USER_INFO_CLONED(state, info) {
      state.userInfoCloned = info;
    },
    SET_ON_MOBILE(state, onmobile) {
      state.onMobile = onmobile;
    },
    SET_PROJECTS(state, projects) {
      state.projects = projects;
    },
    ADD_NEW_PROJECT(state, project) {
      state.projects.push(project);
    },
    SET_FILTER_STATUS(state, status) {
      state.filterStatus = status;
    },
    SET_FILTER_TEXT_PROJECTS(state, filterText) {
      state.filterTextProjects = filterText;
    },
    SET_FILTER_TEXT_CLIENTS(state, filterText) {
      state.filterTextClients = filterText;
    },
    SET_CLIENTS(state, clients) {
      state.clients = clients;
    },
    SET_SELECTED_PROJECT(state, project) {
      state.selectedProject = project;
    },
    UPDATE_PROJECT_DETAILS(state, project) {
      state.selectedProject.dateAccepted = project.dateAccepted;
      state.selectedProject.dateEnquiry = project.dateEnquiry;
      state.selectedProject.dateProposal = project.dateProposal;
      state.selectedProject.dateStarted = project.dateStarted;
      state.selectedProject.status = project.status;
      state.selectedProject.types = project.types;
      state.selectedProject.projectID = project.projectID;
      state.selectedProject.note = project.note;
    },
    UPDATE_WORKITEMS(state, items) {
      state.selectedProject.workItems = items;
    },
    UPDATE_EXPENSES(state, items) {
      state.selectedProject.expenses = items;
    },
    UPDATE_INVOICES(state, items) {
      state.selectedProject.invoices = items;
    },
    UPDATE_TIMESHEETS(state, items) {
      state.selectedProject.timesheets = items;
    },
    // UPDATE_CLIENT_TO_PROJECT(state, client) {
    //   state.selectedProject.client = client;
    //   state.selectedProject.cid = client.cid;
    // }
  },
  actions: {
    setLoginError(state, error) {
      commit("SET_LOGIN_ERROR", error);
    },
    setSelectedProject({ commit }, project) {
      commit("SET_SELECTED_PROJECT", project);
    },
    setFilterStatus({ commit }, status) {
      commit("SET_FILTER_STATUS", status);
    },
    setFilterTextProject({ commit }, filterText) {
      commit("SET_FILTER_TEXT_PROJECTS", filterText.toLowerCase());
    },
    setFilterTextClient({ commit }, filterText) {
      commit("SET_FILTER_TEXT_CLIENTS", filterText.toLowerCase());
    },
    // ------------------------------------------
    setUserInfo({ commit }, info) {
      commit("SET_USER_INFO", info);
    },
    async updateUserInfo({ state, commit }, obj) {

      // define the update object
      let newObj = { [`${obj.field}`]: obj.data };

      // update firestore
      await connect.updateUserInfo(state.userAuth.uid, newObj);

      // get the latest info and set it again (bit heavy handed...)
      let updatedUserInfo = await connect.getUserInfo(state.userAuth.uid);
      commit("SET_USER_INFO", updatedUserInfo);
    },
    createUserInfoClone({ state, commit }) {
      let info = state.userInfo;
      let clonedInfo = JSON.parse(JSON.stringify(info));
      commit("SET_USER_INFO_CLONED", clonedInfo);
    },
    // -----------------------------------------
    setUser({ commit, dispatch, state }, userAuth) {

      //debugger;
      // if no user is passed in then clear the store
      if (!userAuth) {
        commit('SET_USER_AUTH', null);
        commit('SET_USER_INFO', {});
        commit('SET_PROJECTS', null);
        commit('SET_CLIENTS', null);
        return;
      }

      // commit the userAuth so can call upon it later
      commit('SET_USER_AUTH', userAuth);

      // retrieve data for this user
      dispatch("getClients");
      dispatch("getProjects");

    },
    matchProjectWithClient({ state }) {
      let projects = state.projects;
      let clients = state.clients;

      // if either one of them is not defined then stop right here
      if (!projects || !clients) return;

      // step through all projects and assign the correct client to the project
      projects.forEach(p => {
        let client = clients.find(c => c.cid == p.cid);
        Vue.set(p, "client", client);
        Vue.set(p, "cid", client ? client.cid : "");
      });
    },
    async createProject({ state, commit }, project) {
      //debugger;
      // add the current uid so we know who this project belongs to!
      project.uid = state.userAuth.uid;
      // pass this project over to be stored
      let pid = await connect.createProject(project);
      debugger;
      project.pid = pid;
      commit("ADD_NEW_PROJECT", project);
      commit("SET_SELECTED_PROJECT", project);
    },
    deleteProject({ dispatch }, project) {
      let id = project._id;

    },
    async updateProject({ commit }, project) {
      //debugger;
      // we are mostly already given a cloned project but to make sure
      let clone = JSON.parse(JSON.stringify(project));
      // remove all calculated values we have attached to this project
      clearProjectCalcs(project);
      // remove the reference to the full client details object
      delete clone.client;
      // and pass it on to firestore
      await connect.updateProject(clone);
      // now update our internal link to this project
      commit("UPDATE_PROJECT_DETAILS", project);
    },
    async setClientToProject({ commit, state, dispatch }, client) {

      // if the current selected project has not got a reactive prop client then set this
      if (!state.selectedProject.cid) {
        Vue.set(state.selectedProject, "client", client);
        Vue.set(state.selectedProject, "cid", client ? client.cid : "");
      }
      else {
        state.selectedProject.client = client;
        state.selectedProject.cid = client.cid;
      }
      // and ask the updateProject function to take care of saving
      await dispatch("updateProject", state.selectedProject);
    },
    saveNewProject({ dispatch }, project) {

    },
    async getProjects({ state, commit, dispatch }) {
      let projects = await connect.getProjects(state.userAuth.uid);
      console.log("Firestore - retrieved projects - #" + projects.length);
      // update some calculated values
      projects.forEach(p => calculateProjectStatus(p));
      // now hand over to the store
      commit('SET_PROJECTS', projects);
      dispatch("matchProjectWithClient");
    },
    async getClients({ state, commit, dispatch }) {
      let clients = await connect.getClients(state.userAuth.uid);
      console.log("Firestore - retrieved clients - #" + clients.length);
      commit('SET_CLIENTS', clients);
      dispatch("matchProjectWithClient");
      //dispatch("getAllClients");
    },
    async createClient({ dispatch, state }, client) {
      client.uid = state.userAuth.uid;
      await connect.createClient(client);
      dispatch("getClients");
    },
    async updateClient({ dispatch, state }, client) {
      // ensure the incoming client has a cid prop
      if (!client.hasOwnProperty('cid'))
        throw Error("Incoming client object does not have a 'cid' property!");
      await connect.updateClient(client);
      dispatch("getClients");
    },
    async deleteClient({ dispatch, state }, client) {
      await connect.deleteClient(client);
      dispatch("getClients");
    },
    // ----------------------------------
    async createObjItem({ dispatch, state }, obj) {
      let pid = state.selectedProject.pid;
      await connect.createObjItem(pid, obj);
      dispatch("getCurrentObjItems", obj.context);
    },
    async updateObjItem({ dispatch, state }, obj) {
      let pid = state.selectedProject.pid;
      await connect.updateObjItem(pid, obj);
      dispatch("getCurrentObjItems", obj.context);
    },
    async deleteObjItem({ dispatch, state }, obj) {
      let pid = state.selectedProject.pid;
      await connect.deleteObjItem(pid, obj);
      dispatch("getCurrentObjItems", obj.context);
    },
    async getCurrentObjItems({ commit, state }, context) {
      let pid = state.selectedProject.pid;
      let items = await connect.getCurrentObjItems(pid, context);
      commit('UPDATE_' + context.toUpperCase(), items || []);
      calculateProjectStatus(state.selectedProject);
    },
    // -----------------------------------------

  },
  getters: {
    getDashboardDateHorizon(state) {
      return [
        { text: "Last 12 Month", value: "Last12Month" },
        { text: "Tax Year 2020/2021", value: "2020/2021" },
        { text: "Tax Year 2019/2020", value: "2019/2020" },
      ];
    },
    getDashboardInfo(state) {
      return (mode) => {
        return getDashboardInfo(state, mode);
      };
    },
    getRelatedProjects(state) {
      return (cid) => {
        return state.projects.filter(p => p.cid == cid);
      };
    },
    // loginError(state) {
    //   return state.loginError;
    // },
    isLoggedIn(state) {
      return !!state.userAuth;
    },
    onMobile(state) {
      return !!state.onMobile;
    },
    statuses(state) {
      return state.userInfo.statuses;
    },
    types(state) {
      return state.userInfo.types;
    },
    hasSelectedProject(state) {
      return !!state.selectedProject;
    },
    selectedProject(state) {
      return state.selectedProject;
    },
    selectedClient(state) {
      if (state.selectedProject)
        return state.selectedProject.client;
      return null;
    },
    selectedProjectWorkItems(state) {
      let obj = { ...state.selectedProject.workItems };
      let arr = Object.keys(obj).map((k) => obj[k]);
      return arr;
    },
    getWorkitemName(state) {
      return (wiid) => {
        let arr = { ...state.selectedProject.workItems };
        let match = arr.find(item => item.wiid == wiid);
        if (match) return match.name;
        return "-- not found --";
      };
    },
    userAuth(state) {
      return state.userAuth;
    },
    userInfo(state) {
      return state.userInfo;
    },
    userInfoCloned(state) {
      return state.userInfoCloned;
    },
    projects(state) {
      return state.projects;
    },
    filterStatus(state) {
      return state.filterStatus;
    },
    inFilteredMode(state) {
      return state.filterText.length > 0;
    },
    filteredProjects(state) {

      let arrClients = [];
      if (state.filterTextClients)
        arrClients = (state.clients || []).filter(filterClient(state.filterTextClients));
      let cids = arrClients.map(client => client.cid);

      let filter = p => {
        // first check the status
        let b1 = p.status.toLowerCase() == state.filterStatus.toLowerCase();
        if (state.filterStatus.toLowerCase().includes("all")) b1 = true;

        // check the client search
        let b2 = cids.includes(p.cid);
        if (state.filterTextClients.length == 0 && cids.length == 0) b2 = true;

        // AND
        return b1 && b2;

      };

      let arr = (state.projects || []).filter(filter);
      arr.sort((a, b) => (a.created < b.created) ? 1 : -1);
      return arr;
    },
    clients(state) {
      return state.clients;
    },
    filteredClients(state) {
      let arr = (state.clients || []).filter(filterClient(state.filterTextClients));
      // arr.sort((a, b) => (a.created < b.created) ? 1 : -1);
      return arr;
    },
    // -----------------------------------------------------------------------
    getInvoiceAmount(state) {
      return (momentDay) => {

        let filterInfo = i => {
          if (!i.datePaid) return false;
          let day = moment(i.datePaid);
          return (day.month() == momentDay.month() && day.year() == momentDay.year());
        };

        let calcProjectInvoiceTotal = project => {
          let invoicesSum = Enumerable.from(project.invoices)
            .select(p => p.value)
            .where(filterInfo)
            .sum(p => Number(p.amount));
          return invoicesSum;
        };

        // 
        let retTotal = Enumerable.from(state.projects)
          .select(calcProjectInvoiceTotal)
          .sum(s => s);

        return retTotal;

      };
    },
    getExpensesAmount(state) {
      return (momentDay) => {

        let filterInfo = i => {
          let day = moment(i.date);
          return (day.month() == momentDay.month() && day.year() == momentDay.year());
        };

        let calcProjectExpensesTotal = project => {
          let expensesSum = Enumerable.from(project.expenses)
            .select(p => p.value)
            .where(filterInfo)
            .sum(p => Number(p.value));
          return expensesSum;
        };

        // 
        let retTotal = Enumerable.from(state.projects)
          .select(calcProjectExpensesTotal)
          .sum(s => s);

        return retTotal;

      };
    },
    getHoursMonth(state) {
      return (momentDay) => {

        let filterInfo = i => {
          if (!i.date) return false;
          let day = moment(i.date);
          return (day.month() == momentDay.month() && day.year() == momentDay.year());
        };

        let calcTotalHours = project => {
          let totalHours = Enumerable.from(project.timesheets)
            .select(ts => ts.value)
            .where(filterInfo)
            .select(ts => {
              let hours = Number(ts.timeHours);
              let mins = Number(ts.timeMins);
              hours += Math.floor(mins / 60);
              let remainder = (mins % 60);
              if (remainder > 0)
                hours += (remainder / 60);
              return hours;
            })
            .sum(ts => ts);
          return totalHours;
        };

        // 
        let retTotal = Enumerable.from(state.projects)
          .select(calcTotalHours)
          .sum(s => s);

        return retTotal.toFixed(1);

      };
    },
    getCities(state) {
      // given 'horizon' it returns an array of cities that have had paid invoices
      return (horizon) => {

        let dayStart = moment();
        let dayEnd = moment().endOf('month');

        if (horizon == "Last12Month") {
          let fistOfThisMonth = moment().set("date", 1);
          dayStart = fistOfThisMonth.subtract(11, "months");
        }

        let filterInfo = i => {
          if (!i.datePaid) return false;
          let day = moment(i.datePaid);
          return day >= dayStart && day <= dayEnd;
        };

        let filterPaidInvoice = project => {
          let retCity = Enumerable.from(project.invoices)
            .select(p => p.value)
            .where(filterInfo);
          return retCity;
        };

        // 
        let retTotal = Enumerable.from(state.projects)
          .where(filterPaidInvoice)
          .select(p => p.client.city)
          .distinct(city => city)
          .toArray();

        return retTotal;

      };
    },
    getInvoicedByArea(state) {
      // given a 'city' and 'horizon' it returns a total paid invoiced amount (for that period).
      return (city, horizon) => {

        let dayStart = moment();
        let dayEnd = moment().endOf('month');

        if (horizon == "Last12Month") {
          let fistOfThisMonth = moment().set("date", 1);
          dayStart = fistOfThisMonth.subtract(11, "months");
        }

        let filterInfo = i => {
          if (!i.datePaid) return false;
          let day = moment(i.datePaid);
          return day >= dayStart && day <= dayEnd;
        };

        let calcProjectInvoiceTotal = project => {
          let invoicesSum = Enumerable.from(project.invoices)
            .select(p => p.value)
            .where(filterInfo)
            .sum(p => Number(p.amount));
          return invoicesSum;
        };

        // 
        let retTotal = Enumerable.from(state.projects)
          .where(p => p.client.city == city)
          .select(calcProjectInvoiceTotal)
          .sum(s => s);

        return retTotal;

      };
    },
  },
  modules: {}
});




